export default __webpack_public_path__ + "static/media/rubik-v12-latin-500.57ac687d.ttf";